// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';
import omit from 'lodash/omit';
// Components
import OMAutocompleteInput from '../../components/OMComponents/OMAutocompleteInput/OMAutocompleteInput';
// Helpers
import { enterKey, inputStyleTheme } from '../../constants';
import appendLocale from '../../helpers/appendLocale';
import highlightSuggestion from '../../helpers/highlightSuggestion';

class ProfessionalsPageSearchInput extends Component {
  state = {
    suggestions: [],
    value: ''
  };

  componentWillMount() {
    const { city } = this.props;

    if (city) {
      this.setState({ value: city });
    }
  }

  componentWillReceiveProps({ suggestions, city, locale, address }) {
    if (this.props.city !== city && !city) {
      this.setState({ value: '' });
    }
    if (this.props.city !== city && city) {
      this.setState({ value: city });
    }

    if (this.props.suggestions !== suggestions) {
      const filteredSuggestions = (suggestions && suggestions.map((item => item.tags && item)));
      this.setState({ suggestions: filteredSuggestions });
    }

    if (this.props.address !== address && address && address.length) {
      const inputValue = address[0].address;
      this.setState({ value: inputValue });
    }
  }

  onKeyDown = (event) => {
    if (event.keyCode === enterKey) {
      event.preventDefault();
      this.setState({
        value: event.target.value
      });
    }
  };

  getSuggestionValue = suggestion => (suggestion ? suggestion.address : '');

  getInputValue = (value) => {
    const { queryName } = this.props;
    this.setState({ value }, () => {
      if (value.length === 0) {
        const query = {
          ...(this.props.query || {})
        };
        const modifiedQuery = omit(query, [queryName]);

        this.setState({ suggestions: [] });

        if (this.props.isRealtorsAssociation) {
          browserHistory.push({
            pathname: appendLocale(this.props.locale, '/professionals/realtors-association/search'),
            query: modifiedQuery
          });
        } else if (this.props.isBrokerCommunity) {
          browserHistory.push({
            pathname: appendLocale(this.props.locale, '/professionals/broker/search'),
            query: modifiedQuery
          });
        } else {
          browserHistory.push({
            pathname: appendLocale(this.props.locale, '/professionals/search'),
            query: modifiedQuery
          });
        }
      }
    });
    if (value.trim().length > 0) {
      this.setState({ value });
      this.props.receiveSuggestions({
        query: value,
        type: 'city'
      });
    }
  };

  searchSelectedOption = (value) => {
    const { queryName } = this.props;

    const query = {
      ...(this.props.query || {})
    };

    if (queryName === 'professionals_city') {
      query.professionals_city = value.address;
    }

    if (queryName === 'property_city') {
      query.property_city = value.address;
    }

    if (this.props.isRealtorsAssociation) {
      browserHistory.push({
        pathname: appendLocale(this.props.locale, '/professionals/realtors-association/search'),
        query
      });
    } else if (this.props.isBrokerCommunity) {
      browserHistory.push({
        pathname: appendLocale(this.props.locale, '/professionals/broker/search'),
        query
      });
    } else {
      browserHistory.push({
        pathname: appendLocale(this.props.locale, '/professionals/search'),
        query
      });
    }
  };

  render() {
    const searchInputPlaceholder = this.props.placeholder;
    return (
      <OMAutocompleteInput
        inputValue={this.state.value}
        initialValue={this.state.value}
        placeholder={searchInputPlaceholder}
        theme={inputStyleTheme}
        getInputValue={this.getInputValue}
        suggestions={this.state.suggestions}
        getSuggestionValue={this.getSuggestionValue}
        selectedSuggestion={this.searchSelectedOption}
        shouldRenderSuggestions={() => true}
        onKeyDown={() => {}}
        deferRequestBy={300}
        autoFocus={this.state.autoFocus}
        className={this.props.className}
        renderSuggestions={highlightSuggestion}
        isProfessionals
        isDeferredBlur
        isValid
      />
    );
  }
}

ProfessionalsPageSearchInput.propTypes = {
  suggestions: PropTypes.array,
  locale: PropTypes.string,
  translate: PropTypes.func,
  city: PropTypes.string,
  receiveSuggestions: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.any,
  searchAddress: PropTypes.func,
  address: PropTypes.array,
  isBrokerCommunity: PropTypes.bool,
  isRealtorsAssociation: PropTypes.bool,
  queryName: PropTypes.string,
  query: PropTypes.object
};

export default ProfessionalsPageSearchInput;
